'use client';

import React, { useState } from 'react';
import authService from '../src/services/auth.service';

const Header = ({ onMenuClick }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await authService.logout();
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  return (
    <header className="h-16 sticky top-0 z-30 flex items-center justify-between px-4 lg:px-6 bg-[#222222] border-b border-white/5 shadow-md">
      <div className="flex items-center space-x-4">
        {/* Logo Section */}
        
      </div>

      <div className="flex items-center space-x-4">
        {/* Status Badge */}
        <div className="hidden sm:flex items-center space-x-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/5">
          <div className="w-2 h-2 rounded-full bg-[#0ab39c]" />
          <span className="text-[11px] font-bold text-white uppercase tracking-widest">Online</span>
        </div>

        {/* User Profile */}
        <div className="relative flex items-center space-x-3 ml-2 pl-4 border-l border-white/10">
          <button 
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="flex items-center focus:outline-none group" 
            aria-label="User menu"
          >
            <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center overflow-hidden border border-white/20 group-hover:border-white/40 transition-all shadow-xl">
              <img 
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" 
                alt="Profile" 
                className="w-full h-full object-cover"
              />
            </div>
          </button>

          {dropdownOpen && (
            <>
              {/* Click outside overlay */}
              <div 
                className="fixed inset-0 z-40 cursor-default" 
                onClick={() => setDropdownOpen(false)}
              />
              
              {/* Dropdown Menu */}
              <div className="absolute right-0 top-full mt-2 w-52 rounded-xl bg-[#282828] border border-white/10 shadow-2xl py-1.5 z-50 transform origin-top-right transition-all duration-200">
                {/* User Info Header */}
                <div className="px-4 py-2.5 border-b border-white/5">
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Signed in as</p>
                  <p className="text-xs font-semibold text-white truncate mt-0.5">Administrator</p>
                </div>

                {/* Dropdown Items */}
                <div className="p-1">
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center space-x-2.5 px-3 py-2 text-xs font-semibold text-red-400 hover:bg-red-500/10 hover:text-red-300 rounded-lg transition-colors duration-150 text-left"
                  >
                    <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                    </svg>
                    <span>Sign Out</span>
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
